export { default as StepCirugia  } from "./StepCirugia"
export { default as StepMedico   } from "./StepMedico"
export { default as StepPaciente } from "./StepPaciente"
export { default as StepClinica  } from "./StepClinica"
export { default as StepExtras   } from "./StepExtras"
